module.exports = __webpack_public_path__ + "img/05-min.6411517e.jpg";